import { Controller, Payload } from "../../controller";
import { ApplicationState } from "../../store";
import { bindActionCreators, Dispatch } from "redux";

import { CanalDistribuicao, initialValueState, CanalDistribuicaoState, CanalDistribuicaoActions, ResumoMpMovimentacoesByCanalDistProps, FiltroReadMovCanal, EstoqueDistCalc, ChartBarSeries, TotalFaturadoProps, intialValueCanalDistribuicao } from "./canalDist.model"
import { action } from "typesafe-actions";
import { call, put, takeLatest } from "redux-saga/effects";
import { Funcionario, FuncionarioActions, FuncionarioState } from "../funcionario/funcionario.model";
import { funcionarioController } from "../funcionario/funcionario.controll";
import { ac } from "react-router/dist/development/route-data-H2S3hwhf";
import { ResultDb } from "../../services/db";
import { EstoqueCanalDistriuicao, ItemMov, Movimentacao } from "../../data.types";
import { MovActions, MovState } from "../movimentacoes/mov.model";
import { BarSeriesType, LineSeriesType } from "@mui/x-charts";
import { getNewId, isEmpty } from "../../services/utils";
import { ContasActions, ContasState } from "../contas/contas.model";
import { contasController } from "../contas/contas.controll";
import { movController } from "../movimentacoes/mov.controll";
import { get } from "http";

export interface CanalDistribuicaoViewProps {
    canalDistribuicaoState: CanalDistribuicaoState
    canalDistribuicaoActions: CanalDistribuicaoActions
    funcionarioState: FuncionarioState
    funcionarioActions: FuncionarioActions
    contasState: ContasState
    contasActions: ContasActions
}


class CanalDistribuicaoController extends Controller<CanalDistribuicao, CanalDistribuicaoState, CanalDistribuicaoActions> {

    constructor() {
        super(initialValueState.row.type, initialValueState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
            setTabValue: `@${this.moduloName}/SET_TAB_VALUE`,
            setSituacao: `@${this.moduloName}/SET_SITUACAO`,
            READ_MOVS_CANAL_DIST: `@${this.moduloName}/READ_MOVS_CANAL_DIST`,
            getResumoMpMovByCanalDist: `@${this.moduloName}/GET_RESUMO_MP_MOV_BY_CANAL_DIST`,
            readCanalDistAbertos: `@${this.moduloName}/READ_CANAL_DIST_ABERTOS`,
            calcSaldoEstoqueCanal: `@${this.moduloName}/CALC_SALDO_ESTOQUE_CANAL`,
            getResumoMpGroupByData: `@${this.moduloName}/GET_RESUMO_MP_GROUP_BY_DATA`,
            setFiltro: `@${this.moduloName}/SET_FILTRO`,
            readCanalDistByPeriodo: `@${this.moduloName}/READ_CANAL_DIST_BY_PERIODO`,
            getTotalFaturadoByPeriodo: `@${this.moduloName}/GET_TOTAL_FATURADO_BY_PERIODO`,
            readCanalDistByData: `@${this.moduloName}/READ_CANAL_DIST_BY_DATA`,
            getCanalDistByFuncionario: `@${this.moduloName}/GET_CANAL_DIST_BY_FUNCIONARIO`,
            addCanalDist: `@${this.moduloName}/ADD_CANAL_DIST`,
            abrirCanalDist: `@${this.moduloName}/ABRIR_CANAL_DIST`,
            setShowModalEditarCanalDist: `@${this.moduloName}/SET_SHOW_MODAL_EDITAR_CANAL_DIST`,
            getCanalDistAberto: `@${this.moduloName}/GET_CANAL_DIST_ABERTO`,
            readCanalDistByDia: `@${this.moduloName}/READ_CANAL_DIST_BY_DIA`,
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            setTabValue: (value) => action(this.actionsType.setTabValue, { value, this: this }),
            setSituacao: (situacao) => action(this.actionsType.setSituacao, { situacao, this: this }),
            readMovsCanal: (filtro) => action(this.actionsType.READ_MOVS_CANAL_DIST, { this: this, filtro }),
            getResumoMpMovByCanalDist: () => action(this.actionsType.getResumoMpMovByCanalDist, { this: this }),
            readCanalDistAbertos: () => action(this.actionsType.readCanalDistAbertos, { this: this }),
            calcSaldoEstoqueCanal: () => action(this.actionsType.calcSaldoEstoqueCanal, { this: this }),
            getResumoMpGroupByData: (filtro) => action(this.actionsType.getResumoMpGroupByData, { this: this, filtro }),
            setFiltro: (filtro) => action(this.actionsType.setFiltro, { this: this, filtro }),
            readCanalDistByPeriodo: (filtro) => action(this.actionsType.readCanalDistByPeriodo, { this: this, filtro }),
            getTotalFaturadoByPeriodo: (filtro) => action(this.actionsType.getTotalFaturadoByPeriodo, { this: this, filtro }),
            readCanalDistByData: (filtro) => action(this.actionsType.readCanalDistByData, { this: this, filtro }),
            getCanalDistByFuncionario: (funcionario) => action(this.actionsType.getCanalDistByFuncionario, { this: this, funcionario }),
            addCanalDist: (funcionario) => action(this.actionsType.addCanalDist, { this: this, funcionario }),
            abrirCanalDist: (showCad) => action(this.actionsType.abrirCanalDist, { this: this, showCad }),
            setShowModalEditarCanalDist: (show) => action(this.actionsType.setShowModalEditarCanalDist, { this: this, show }),
            getCanalDistAberto: () => action(this.actionsType.getCanalDistAberto, { this: this }),
            readCanalDistByDia: (data) => action(this.actionsType.readCanalDistByDia, { this: this, data }),
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.setTabValue, this.setTabValueEffect),
            takeLatest(this.actionsType.setSituacao, this.setSituacaoEffect),
            takeLatest(this.actionsType.READ_MOVS_CANAL_DIST, this.readMovCanalDistEffects),
            takeLatest(this.actionsType.getResumoMpMovByCanalDist, this.getResumoMpMovByCanalDistEffects),
            takeLatest(this.actionsType.readCanalDistAbertos, this.readCanalDistAbertosEffect),
            takeLatest(this.actionsType.calcSaldoEstoqueCanal, this.calcSaldoEstoqueCanalEffects),
            takeLatest(this.actionsType.set, this.setEffects),
            takeLatest(this.actionsType.getResumoMpGroupByData, this.getResumoMpGroupByDataEffects),
            takeLatest(this.actionsType.setFiltro, this.setFiltroEffect),
            takeLatest(this.actionsType.readCanalDistByPeriodo, this.readCanalDistByPeriodoEffects),
            takeLatest(this.actionsType.getTotalFaturadoByPeriodo, this.getTotalFaturadoByPeriodoEffects),
            takeLatest(this.actionsType.readCanalDistByData, this.readCanalDistByDataEffects),
            takeLatest(this.actionsType.getCanalDistByFuncionario, this.getCanalDistByFuncionarioEffects),
            takeLatest(this.actionsType.addCanalDist, this.addCanalDistEffects),
            takeLatest(this.actionsType.abrirCanalDist, this.abrirCanalDistEffects),
            takeLatest(this.actionsType.setShowModalEditarCanalDist, this.setShowModalEditarCanalDistEffect),
            takeLatest(this.actionsType.getCanalDistAberto, this.getCanalDistAbertoEffect),
            takeLatest(this.actionsType.readCanalDistByDia, this.readCanalDistByDiaEffects),
        ]
    }


            

    getCanalDistAberto = async ():Promise<ResultDb<CanalDistribuicao>> => {
        try {
            //se tiver um canal ja aberto no state, retorna ele
            if(this.state.canalAberto && this.state.canalAberto._id){
                return { status: "ok", msg: "Canal de distribuição aberto encontrado.", row: this.state.canalAberto }
            }
            //se não tiver canal aberto no state, busca no banco de dados por um canal aberto para o funcionário logado
            let funcLogado = funcionarioController.state.funcLogado;
            const resp: ResultDb<CanalDistribuicao> = await this.getCanalDistByFuncionario(funcLogado);
            switch (resp.status) {
                case "ok":return { status: "ok", msg: "Canal de distribuição aberto encontrado.", row: resp.row! as CanalDistribuicao }
                case "not_found": 
                    let respAdd = await this.addCanalDist(funcLogado);
                    return respAdd;
                case "error": return { status: "error", msg: resp.msg as string } as ResultDb<CanalDistribuicao>
            }


        } catch (error:any) {
            console.error("Error in getCanalDistAberto:", error);
            let msg = "Ops, ocorreu uma falha em getCanalDistAberto, detalhes: ";
            let err = msg + (typeof error === 'object' ? JSON.stringify(error) : error);
            return {status:"error", msg: err} as ResultDb<CanalDistribuicao>
        }
    }

    private* readCanalDistByDiaEffects(actions: Payload) {
        const vm = actions.payload.this as CanalDistribuicaoController;
        const data = actions.payload.data;
        console.log("chamou readCanalDistByDiaEffects", data);
        try {
            let dtIni = new Date(data);
            dtIni.setHours(0,0);
            //ajustar timezone para -3:00
            dtIni = new Date(dtIni.getTime() + (-3 * 60 * 60 * 1000));
            let dtFim = new Date(data);
            dtFim.setHours(23,59);
            //ajustar timezone para -3:00
            dtFim = new Date(dtFim.getTime() + (-3 * 60 * 60 * 1000));
            yield put(vm.reducer.resultAfterEffects(
                {...vm.state, loadingRows: true, msg: "Buscando canais de distribuição por dia..."},
                vm.actionsType.readCanalDistByDia
            ))       
            let selector = {
                "type": { "$eq": "canaldist" } ,
                "data": {
                    "$gte": dtIni ,
                    "$lte": dtFim
                }                    
            }   
            let index = {
                fields: ["type", "data"],
                name: "idx_canal_dist_by_dia",
            }
            const resp: ResultDb<CanalDistribuicao> = yield call(vm.db.filterDeep,selector, index);
            if(resp.status === "ok"){
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loadingRows: false, rowsSelected: resp.rows as CanalDistribuicao[], msg: "Busca dos canais de distribuição por dia concluida.", status: "ok", error: false, changeList: new Date().toISOString() },
                    vm.actionsType.readCanalDistByDia
                ))
            } else {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loadingRows: false, msg: resp.msg as string, status: resp.status, error: true },
                    vm.actionsType.readCanalDistByDia
                ))
            }

        } catch (error:any) {
            console.error("Error in readCanalDistByDiaEffects:", error);
            let msg = "Ops, ocorreu uma falha em readCanalDistByDiaEffects, detalhes: " + error.message
            let err = msg + (typeof error === 'object' ? JSON.stringify(error) : error);
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loadingRows: false, msg: err, status: "error", error: true },
                vm.actionsType.readCanalDistByDia
            ))
        }
    }

    private* getCanalDistAbertoEffect(actions: Payload) {
        const vm = actions.payload.this as CanalDistribuicaoController
        let resp: ResultDb<CanalDistribuicao> = yield call(vm.getCanalDistAberto);
        if(resp.status === "ok"){
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, canalAberto: resp.row as CanalDistribuicao },
                vm.actionsType.getCanalDistAberto
            ))
        } else {
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, canalAberto: {} as CanalDistribuicao, msg: resp.msg as string, status: resp.status, error: true, showAlert: true },
                vm.actionsType.getCanalDistAberto
            ))
        }
    }    

    private * setShowModalEditarCanalDistEffect(actions: Payload) {
        const vm = actions.payload.this as CanalDistribuicaoController;
        const show = actions.payload.show;
        yield put(vm.reducer.resultAfterEffects(
            { ...vm.state, showModalEditarCanalDist: show },
            vm.actionsType.setShowModalEditarCanalDist
        ))
    }

    private * abrirCanalDistEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<CanalDistribuicao, CanalDistribuicaoState, CanalDistribuicaoActions>;
        const showCad = actions.payload.showCad;
        let canalDist = {
            ...intialValueCanalDistribuicao,
            data: new Date().toISOString(),
        } as CanalDistribuicao

        yield put(vm.reducer.resultAfterEffects(
            { ...vm.state, row: canalDist, showModalEditarCanalDist: showCad },
            vm.actionsType.setFiltro
        ))
    }
  

    private * setFiltroEffect(actions: Payload) {
        const vm = actions.payload.this as Controller<CanalDistribuicao, CanalDistribuicaoState, CanalDistribuicaoActions>;
        const filtro: FiltroReadMovCanal = actions.payload.filtro;
        try {
            console.log("chamou setFiltroEffect", filtro);
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, filtroMovCanal: filtro },
                vm.actionsType.setFiltro
            ))
            yield put(vm.reducer.actions.getResumoMpGroupByData(filtro));
            yield put(vm.reducer.actions.getTotalFaturadoByPeriodo(filtro));
            yield put(vm.reducer.actions.readCanalDistByPeriodo(filtro));
            //yield put (movController.reducer.actions.readMovItensPeriodo(filtro))
        } catch (error: any) {
            console.log("error setFiltroEffect", error);
            let msg = "Ops, ocorreu uma falha em setFiltroEffect, detalhes: ";
            let err = msg + (typeof error === 'object' ? JSON.stringify(error) : error);
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.setFiltro
            ))
        }

    }

    private * readCanalDistByDataEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<CanalDistribuicao, CanalDistribuicaoState, CanalDistribuicaoActions>;
        try {
            let filtro: FiltroReadMovCanal = actions.payload.filtro;
            if (filtro.dtIni && filtro.dtFim) {
                console.log("chamou readCanalDistByDataEffects", filtro);
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: true, msg: "Buscando canais de distribuição por período..." },
                    vm.actionsType.readCanalDistByPeriodo
                ))
                let resp: ResultDb<CanalDistribuicao> = yield call(vm.db.filterView, {
                    viewName: "func/canais_dist_by_data",
                    opt: {
                        include_docs: true,
                        startkey: [filtro.dtIni.substr(0, 4), filtro.dtIni.substr(5, 2), filtro.dtIni.substr(8, 2)],
                        endkey: [filtro.dtFim.substr(0, 4), filtro.dtFim.substr(5, 2), filtro.dtFim.substr(8, 2), {}],
                        //group_level: 2
                    },
                    resultViewFull: false
                });
                console.log("resp readCanalDistByDataEffects", resp);
                if (resp.status === "ok") {
                    yield put(vm.reducer.resultAfterEffects(
                        { ...vm.state, loading: false, rows: resp.rows as CanalDistribuicao[], msg: "Busca dos canais de distribuição por período concluida.", status: "ok", error: false, changeList: new Date().toISOString() },
                        vm.actionsType.readCanalDistByPeriodo
                    ))
                } else {
                    yield put(vm.reducer.resultAfterEffects(
                        { ...vm.state, loading: false, msg: resp.msg as string, status: "error", error: true, showAlert: true },
                        vm.actionsType.readCanalDistByPeriodo
                    ))
                }
            }
        } catch (error: any) {
            console.log("error readCanalDistByDataEffects", error);
            let msg = "Ops, ocorreu uma falha em readCanalDistByDataEffects, detalhes: ";
            let err = msg + (typeof error === 'object' ? JSON.stringify(error) : error);
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.readCanalDistByPeriodo
            ))
        }
    }

    private * readCanalDistByPeriodoEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<CanalDistribuicao, CanalDistribuicaoState, CanalDistribuicaoActions>;
        try {
            //filtro com dtIni, dtFim e periodo
            let filtro: FiltroReadMovCanal = actions.payload.filtro;
            if (filtro.dtIni && filtro.dtFim && filtro.periodo) {

                console.log("chamou readCanalDistByPeriodoEffects", filtro);
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: true, msg: "Carregando total faturado por período..." },
                    vm.actionsType.readCanalDistByPeriodo
                ))

                type ResultDFull = { id: string, key: string[], value: any }
                let resp: ResultDb<ResultDFull[]> = yield call(vm.db.filterView, {
                    viewName: "func/faturamento_canais_group_data",
                    resultViewFull: true,
                    opt: {
                        include_docs: false,
                        startkey: [filtro.dtIni.substr(0, 4), filtro.dtIni.substr(5, 2), filtro.dtIni.substr(8, 2)],
                        endkey: [filtro.dtFim.substr(0, 4), filtro.dtFim.substr(5, 2), filtro.dtFim.substr(8, 2)],
                        group_level: 3
                    }
                });

                console.log("resp readCanalDistByPeriodo", resp);
                if (resp.status === "ok") {
                    if (resp.rows) {
                        //key 0 1 2 ano mes dia, value total
                        //montar um array com os campos data e total    
                        let dados: TotalFaturadoProps[] = [];
                        resp.rows.map((row) => {
                            let data = "";
                            let id = [];
                            //sempre vai ter os 3 campos
                            data = `${row.key[2]}/${row.key[1]}/${row.key[0]}`
                            id = [row.key[0], row.key[1], row.key[2]]
                            dados.push({ id: id, data: data, total: row.value })
                        });
                        //ordenar dados por id
                        dados.sort((a, b) => a.id < b.id ? 1 : -1);
                        console.log("dados ordenado", dados);
                        yield put(vm.reducer.resultAfterEffects(
                            { ...vm.state, loading: false, rowsTotalFatPeriodo: dados, msg: "Total faturado por período carregado.", status: "ok", error: false, changeList: new Date().toISOString() },
                            vm.actionsType.readCanalDistByPeriodo
                        ))
                    }
                } else {
                    yield put(vm.reducer.resultAfterEffects(
                        { ...vm.state, loading: false, msg: resp.msg as string, },
                        vm.actionsType.readCanalDistByPeriodo
                    ))
                }
            }
        } catch (error: any) {
            console.log("error readCanalDistByPeriodo", error);
            let msg = "Ops, ocorreu uma falha em readCanalDistByPeriodo, detalhes: ";
            let err = msg + (typeof error === 'object' ? JSON.stringify(error) : error);
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.readCanalDistByPeriodo
            ))
        }
    }

    private * setEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<CanalDistribuicao, CanalDistribuicaoState, CanalDistribuicaoActions>;
        try {
            let canalDist = vm.state.row;
            console.log("chamou setEffects", canalDist);
            yield put(vm.reducer.actions.calcSaldoEstoqueCanal());
            yield put(vm.reducer.actions.readMovsCanal({ canal_id: canalDist._id }));
            yield put(vm.reducer.actions.getResumoMpMovByCanalDist());
            yield put(contasController.reducer.actions.readResumoMpRecebimentosByCanal(canalDist._id))
        } catch (error: any) {
            console.log("error setEffects", error);
            let msg = "Ops, ocorreu uma falha em setEffects, detalhes: ";
            let err = msg + (typeof error === 'object' ? JSON.stringify(error) : error);
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.setEffects
            ))
        }

    }

    private * getResumoMpGroupByDataEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<CanalDistribuicao, CanalDistribuicaoState, CanalDistribuicaoActions>;
        const { dtIni, dtFim, periodo } = vm.state.filtroMovCanal;
        console.log("chamou getResumoMpGroupByDataEffects", vm);
        try {
            if (dtIni && dtFim && periodo) {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loadCharBar: true, msg: "Carregando resumo dos meios de pagamento..." },
                    vm.actionsType.calcSaldoEstoqueCanal
                ))
                let viewName = "";
                let group_level = 0;
                let indexSerieKey = 0
                switch (periodo) {
                    case "anual":
                        viewName = "func/canal_dist_resum_mp_group_by_ano";
                        group_level = 2;
                        indexSerieKey = 1
                        break;
                    case "mensal":
                        viewName = "func/canal_dist_resum_mp_group_by_mes_ano";
                        group_level = 3;
                        indexSerieKey = 2
                        break;
                    case "diario":
                        viewName = "func/canal_dist_resum_mp_group_by_data";
                        group_level = 4;
                        indexSerieKey = 3
                        break
                }
                let resp: ResultDb<any> = yield call(vm.db.filterView, {
                    viewName: viewName,
                    resultViewFull: true,
                    opt: {
                        include_docs: false,
                        startkey: [dtIni.substr(0, 4), dtIni.substr(5, 2), dtIni.substr(8, 2)],
                        endkey: [dtFim.substr(0, 4), dtFim.substr(5, 2), dtFim.substr(8, 2)],
                        group_level: group_level
                    }
                });
                console.log("resp getResumoMpGroupByDataEffects", resp);

                if (resp.status === "ok") {
                    if (resp.rows && resp.rows.length > 0) {
                        let dataAxis: string[] = []
                        let series: ChartBarSeries[] = [];
                        let dadosKey: { axisId: any[], value: number, axisKey: string, seriesKey: string }[] = [];
                        resp.rows.map((row: { key: any[], value: number }, idx: number) => {
                            //verificar tamanho da key se for 2// somente ano //3ano e mes //4ano mes e dia para axisKey
                            let axisKey = '', axisId = [], seriesKey = row.key[indexSerieKey];
                            switch (periodo) {
                                case "anual"://ano
                                    axisKey = row.key[0];
                                    axisId = [row.key[0]];
                                    break;
                                case "mensal"://ano e mes
                                    axisKey = `${row.key[1]}/${row.key[0]}`;
                                    axisId = [row.key[0], row.key[1]];
                                    break;
                                case "diario":
                                    axisKey = `${row.key[2]}/${row.key[1]}/${row.key[0]}`;
                                    axisId = [row.key[0], row.key[1], row.key[2]];
                                    break;
                            }
                            dadosKey.push({
                                axisId: axisId,
                                axisKey: axisKey,
                                seriesKey: seriesKey,
                                value: row.value
                            })
                        })

                        dadosKey.sort((a, b) => {
                            if (a.axisId > b.axisId)
                                return 1
                            return -1
                        });
                        console.log("dadosKey ordenado", dadosKey);
                        dadosKey.map(rowKey => {
                            let findAxis = dataAxis.find(value => value === rowKey.axisKey)
                            if (!findAxis)
                                dataAxis.push(rowKey.axisKey)
                            let findSeries = series.find(value => value.label === rowKey.seriesKey);
                            if (!findSeries) {
                                series.push({
                                    id: getNewId(),
                                    label: rowKey.seriesKey,
                                    data: [],
                                    type: "bar",
                                    stack: "A",
                                    axisId: rowKey.axisId,
                                })
                            }
                        })
                        console.log("Axis", dataAxis);
                        series.map(serie => {
                            let filterSeries = dadosKey.filter(rowKey => rowKey.seriesKey === serie.label);
                            dataAxis.map(data => {
                                let findAxisInSeries = filterSeries.find(fs => fs.axisKey === data);
                                if (findAxisInSeries) {
                                    serie.data?.push(findAxisInSeries.value)
                                } else serie.data?.push(0);
                            })
                        })

                        console.log("series", series);
                        yield put(vm.reducer.resultAfterEffects(
                            { ...vm.state, loadCharBar: false, chartBarDataAxis: dataAxis, chartBarSeries: series, msg: "Resumo dos meios de pagamento concluido." },
                            vm.actionsType.calcSaldoEstoqueCanal
                        ))

                    }

                } else {
                    yield put(vm.reducer.resultAfterEffects(
                        { ...vm.state, loadCharBar: false, msg: resp.msg as string, },
                        vm.actionsType.getResumoMpGroupByData
                    ))
                }

            }
        } catch (error: any) {
            console.log("error getResumoMpGroupByDataEffects", error);
            let msg = "Ops, ocorreu uma falha em getResumoMpGroupByDataEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loadCharBar: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.getResumoMpGroupByData
            ))
        }
    }

    private * getTotalFaturadoByPeriodoEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<CanalDistribuicao, CanalDistribuicaoState, CanalDistribuicaoActions>;
        const { dtIni, dtFim, periodo } = vm.state.filtroMovCanal;
        try {
            if (dtIni && dtFim && periodo) {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loadChartLine: true, msg: "Carregando total faturado..." },
                    vm.actionsType.calcSaldoEstoqueCanal
                ))

                let viewName = "func/faturamento_canais_group_data";
                let group_level = 0;
                switch (periodo) {
                    case "anual":
                        group_level = 1;
                        break;
                    case "mensal":
                        group_level = 2;
                        break;
                    case "diario":
                        group_level = 3;
                        break
                }
                let resp: ResultDb<any> = yield call(vm.db.filterView, {
                    viewName: viewName,
                    resultViewFull: true,
                    opt: {
                        include_docs: false,
                        startkey: [dtIni.substr(0, 4), dtIni.substr(5, 2), dtIni.substr(8, 2)],
                        endkey: [dtFim.substr(0, 4), dtFim.substr(5, 2), dtFim.substr(8, 2), {}],
                        group_level: group_level
                    }
                });
                console.log("resp faturamento_canais_group_data", resp);
                if (resp.status === "ok") {
                    if (resp.rows && resp.rows.length > 0) {
                        let dataAxis: string[] = []
                        let series: LineSeriesType[] = [];
                        let dadosKey: { axisId: any[], value: number, axisKey: string, seriesKey: string }[] = [];
                        resp.rows.map((row: { key: any[], value: number }, idx: number) => {
                            //verificar tamanho da key se for 2// somente ano //3ano e mes //4ano mes e dia para axisKey
                            let axisKey = '', axisId = [], seriesKey = row.key[group_level];
                            switch (periodo) {
                                case "anual"://ano
                                    axisKey = row.key[0];
                                    axisId = [row.key[0]];
                                    break;
                                case "mensal"://ano e mes
                                    axisKey = `${row.key[1]}/${row.key[0]}`;
                                    axisId = [row.key[0], row.key[1]];
                                    break;
                                case "diario":
                                    axisKey = `${row.key[2]}/${row.key[1]}/${row.key[0]}`;
                                    axisId = [row.key[0], row.key[1], row.key[2]];
                                    break;
                            }
                            dadosKey.push({
                                axisId: axisId,
                                axisKey: axisKey,
                                seriesKey: getNewId(),
                                value: row.value
                            })
                        })

                        dadosKey.sort((a, b) => {
                            if (a.axisId > b.axisId)
                                return 1
                            return -1
                        });

                        series.push({
                            id: getNewId(),
                            label: "Total Faturado",
                            data: [],
                            type: "line",
                            curve: 'linear',
                            stack: 'total',
                            area: false,
                        })

                        console.log("dadosKey ordenado Line", dadosKey);
                        dadosKey.map(rowKey => {
                            dataAxis.push(rowKey.axisKey)
                            series[0].data?.push(rowKey.value);
                        })

                        yield put(vm.reducer.resultAfterEffects(
                            { ...vm.state, loadChartLine: false, chartLineDataAxis: dataAxis, chartLineSeries: series, msg: "Total faturado carregado." },
                            vm.actionsType.getResumoMpGroupByData
                        ))

                    } else {
                        yield put(vm.reducer.resultAfterEffects(
                            { ...vm.state, loadChartLine: false, msg: "Sem registros para exibir.", status: "" },
                            vm.actionsType.getResumoMpGroupByData
                        ))
                    }
                } else {
                    yield put(vm.reducer.resultAfterEffects(
                        { ...vm.state, loadChartLine: false, msg: resp.msg as string, status: "error", error: true, showAlert: true },
                        vm.actionsType.getResumoMpGroupByData
                    ))
                }

            }


        } catch (error: any) {
            console.log("error getTotalFaturadoByPeriodo", error);
            let msg = "Ops, ocorreu uma falha em getTotalFaturadoByPeriodo, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loadChartLine: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.getResumoMpGroupByData
            ))

        }
    }

    private * calcSaldoEstoqueCanalEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<CanalDistribuicao, CanalDistribuicaoState, CanalDistribuicaoActions>;
        try {
            console.log("chamou calcSaldoEstoqueCanalEffects")
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loadingRows: true, msg: "Calculando saldo do estoque do canal de distribuição..." },
                vm.actionsType.calcSaldoEstoqueCanal
            ))
            let canalDist = vm.state.row;
            console.log("canalDist", canalDist);
            //buscar os itens movimentados pelo canal para calcular a saida
            let resp: ResultDb<any> = yield call(vm.db.filterView, {
                viewName: "func/canal_dist_saida_estoque_by_id_canal",
                opt: { key: canalDist._id },
                resultViewFull: false
            });
            console.log("resp calcSaldoEstoqueCanalEffects", resp);
            if (resp.status === "ok") {
                let itensEnt = canalDist.estoque_dist;
                let itensSai = resp.rows as ItemMov[];
                let estoqueCanal: EstoqueDistCalc[] = [];

                //adicionar entradas
                itensEnt.forEach(value => {
                    let index = estoqueCanal.findIndex(e => e.id_item === value.item._id);
                    if (index === -1) {
                        estoqueCanal.push({
                            id_item: value.item._id,
                            desc_item: value.item.descricao,
                            qt_entrada: value.qt,
                            qt_saida: 0,
                            saldo: value.qt,
                        })
                    } else {
                        estoqueCanal[index].qt_entrada += value.qt;
                        estoqueCanal[index].saldo = estoqueCanal[index].qt_entrada;
                    }
                })
                //adicionar saidas e calcular saldo
                itensSai.forEach(value => {
                    let index = estoqueCanal.findIndex(e => e.id_item === value.item._id);
                    if (index === -1) {
                        estoqueCanal.push({
                            id_item: value.item._id,
                            desc_item: value.item.descricao,
                            qt_entrada: 0,
                            qt_saida: value.qt,
                            saldo: -value.qt,
                        })
                    } else {
                        estoqueCanal[index].qt_saida += value.qt;
                        estoqueCanal[index].saldo = estoqueCanal[index].qt_entrada - estoqueCanal[index].qt_saida;
                    }
                })


                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loadingRows: false, estoqueCanal: estoqueCanal, msg: "Cálculo do saldo do estoque do canal de distribuição concluído.", changeList: new Date().toISOString() },
                    vm.actionsType.calcSaldoEstoqueCanal
                ))
            } else {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loadingRows: false, msg: resp.msg as string, changeList: new Date().toISOString() },
                    vm.actionsType.calcSaldoEstoqueCanal
                ))
            }
        } catch (error: any) {
            console.log("error calcSaldoEstoqueCanalEffects", error);
            let msg = "Ops, ocorreu uma falha em calcSaldoEstoqueCanalEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loadingRows: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.calcSaldoEstoqueCanal
            ))
        }
    }

    private * readCanalDistAbertosEffect(actions: Payload) {
        const self = actions.payload.this as CanalDistribuicaoController;
        try {
            yield put(self.reducer.resultAfterEffects(
                { ...self.state, loading: true, msg: "Buscando canais de distribuição abertos...", status: "loading", error: false, showAlert: false },
                self.actionsType.readCanalDistAbertos
            ))
            let resp: ResultDb<CanalDistribuicao> = yield call(self.db.filterView, {
                viewName: "func/canal_dist_all_open_by_id",
                opt: {},
                resultViewFull: false
            });
            console.log("resp readCanalDistAbertosEffect", resp);
            if (resp.status === "ok") {
                //para atualizar o canal que estiver sendo visualizado
                let row = self.state.row;
                if (row._id !== undefined && Array.isArray(resp.rows)) {
                    let index = resp.rows.findIndex((r: CanalDistribuicao) => r._id === row._id)
                    row = index !== -1 ? resp.rows[index] : row;
                    yield put(self.reducer.actions.set(row))
                }

                yield put(self.reducer.resultAfterEffects(
                    { ...self.state, loading: false, rows: resp.rows as CanalDistribuicao[], msg: "Busca dos canais de distribuição abertos concluida.", status: "ok", error: false, changeList: new Date().toISOString() },
                    self.actionsType.readCanalDistAbertos
                ))
            } else {
                yield put(self.reducer.resultAfterEffects(
                    { ...self.state, loading: false, msg: resp.msg as string, status: "error", error: true, showAlert: true },
                    self.actionsType.readCanalDistAbertos
                ))
            }
        } catch (error: any) {
            console.log("error readCanalDistAbertosEffect", error);
            let msg = "Ops, ocorreu uma falha em readCanalDistAbertosEffect, detalhes: ";
            let err = msg + (typeof error === 'object' ? JSON.stringify(error) : error);
            yield put(self.reducer.resultAfterEffects(
                { ...self.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                self.actionsType.readCanalDistAbertos
            ))
        }
    }

    private * setSituacaoEffect(actions: Payload) {
        let vm = actions.payload.this as Controller<CanalDistribuicao, CanalDistribuicaoState, CanalDistribuicaoActions>
        let situacao = actions.payload.situacao;
        try {
            let canalDist = { ...vm.state.row };
            canalDist.situacao = situacao;
            yield put(vm.reducer.actions.update(canalDist))
        } catch (error: any) {
            let msg = "Ops, ocorreu uma falha em setSituacaoEffect, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.setSituacao
            ))
        }
    }

    private * setTabValueEffect(actions: Payload) {
        let vm = actions.payload.this as Controller<CanalDistribuicao, CanalDistribuicaoState, CanalDistribuicaoActions>
        yield put(vm.reducer.resultAfterEffects(
            { ...vm.state, tabValue: actions.payload.value },
            vm.actionsType.setTabValue
        ))
    }

    private * readMovCanalDistEffects(actions: Payload) {
        const self = actions.payload.this as CanalDistribuicaoController;
        let filtro: FiltroReadMovCanal = actions.payload.filtro;
        try {
            yield put(self.reducer.resultAfterEffects(
                { ...self.state, loading: true, msg: "Buscando movimentações do canal de distribuição...", status: "loading", error: false, showAlert: false },
                self.actionsType.readMovCanalDist
            ))
            console.log("filtro readMovCanalDistEffects", filtro);
            let opt: any = {
                include_docs: true,
                key: [filtro.canal_id],
            };
            console.log("opt view", opt);
            let resp: ResultDb<Movimentacao> = yield call(self.db.filterView, {
                viewName: "func/mov_canal_dist_id",
                opt: opt,
                resultViewFull: false
            });
            console.log("resp mov_by_func_data", resp);
            if (resp.status === "ok") {
                yield put(self.reducer.resultAfterEffects(
                    { ...self.state, loading: false, rowsMovCanal: resp.rows as Movimentacao[], msg: "Busca das movmentações do canal de distribuição concluida.", status: "ok", error: false, changeList: new Date().toISOString() },
                    self.actionsType.readMovCanalDist
                ))
            } else {
                yield put(self.reducer.resultAfterEffects(
                    { ...self.state, loading: false, msg: resp.msg as string, status: "error", error: true, showAlert: true },
                    self.actionsType.readMovCanalDist
                ))
            }
        } catch (error: any) {
            console.log("error readMovCanalDistEffects", error);
            let msg = "Ops, ocorreu uma falha em readMovCanalDistEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(self.reducer.resultAfterEffects(
                { ...self.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                self.actionsType.readMovCanalDist
            ))
        }
    }

    private * getResumoMpMovByCanalDistEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<CanalDistribuicao, CanalDistribuicaoState, CanalDistribuicaoActions>;
        console.log("chamou getResumoMpMovByCanalDistEffects",);
        try {
            let canalDist = canalDistController.state.row;
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loadingRows: true, status: "loading", msg: "Carregando resumo dos meios de pagamento das movimentações por canal de distribuição..." },
                vm.actionsType.getResumoMpMovByCanalDist
            ))
            let resp: ResultDb<Movimentacao> = yield call(
                vm.db.filterView, {
                viewName: "func/mov_meiopg_resumo_by_canaldist_id",
                opt: {
                    startkey: [canalDist._id],
                    endkey: [canalDist._id, {}],
                    group_level: 2,
                },
                resultViewFull: true,
            })
            console.log("resp getResumoMpMovByCanalDist", resp);
            if (resp.status === "ok") {
                let resumoMovsMp: ResumoMpMovimentacoesByCanalDistProps[] = Array.isArray(resp.rows)
                    ? resp.rows.map(row => ({
                        descricaoMp: row.key[1], // 0 = _ID canalDist, 1 = meio de pagamento
                        totalMp: row.value,
                    }))
                    : [];
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loadingRows: false, resumoMovsMp: resumoMovsMp, status: "ok", msg: "Resumo dos meios de pagamento carregado com sucesso!", changeList: new Date().toISOString() },
                    vm.actionsType.getResumoMpMovByCanalDist
                ))
            } else {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loadingRows: false, msg: resp.msg as string, status: "error", error: true, showAlert: true },
                    vm.actionsType.getResumoMpMovByCanalDist
                ))
            }


        } catch (error: any) {
            console.log("error getResumoMpMovByCanalDist", error);
            let msg = "Ops, ocorreu uma falha em getResumoMpMovByCanalDist, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loadingRows: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.getResumoMpMovByCanalDist
            ))
        }
    }

    getCanalDistByFuncionario = async (funcionario: Funcionario): Promise<ResultDb<CanalDistribuicao>> => {
        try {
            const resp: ResultDb<CanalDistribuicao> = await this.db.filterView({ viewName: "func/canal_dist_by_func_id", opt: { key: funcionario._id }, resultViewFull: false });
            if (resp.status === "ok") {
                if (resp.rows && resp.rows.length > 0) {
                    let canalDist = resp.rows[0] as CanalDistribuicao;
                    return { status: "ok", row: canalDist }
                } else {
                    return { status: "not_found", msg: "Canal de distribuição não encontrado para o funcionário." } as ResultDb<CanalDistribuicao>;
                }
            } else {
                return { status: "error", msg: resp.msg }
            }
        } catch (error: any) {
            console.log("error getCanalDistByFuncionario", error);
            let msg = "Ops, ocorreu uma falha em getCanalDistByFuncionario, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            return { status: "error", msg: err }
        }
    }


    private * getCanalDistByFuncionarioEffects(actions: Payload) {
        const self = actions.payload.this as CanalDistribuicaoController;
        const funcionario = actions.payload.funcionario as Funcionario;
        try {
            if (!isEmpty(funcionario._id)) {
                console.log("getCanalDistByFuncionarioEffect: funcionario", funcionario);
                yield put(self.reducer.resultAfterEffects(
                    { ...self.state, loading: true, msg: "Buscando canal de distribuição...", status: "loading", error: false, showAlert: false },
                    self.actionsType.getCanalDistByFuncionario
                ))
                //buscar canais de distriuicao relacionado ao funcionario
                //que esteja pendente ou aberto
                const resp: ResultDb<CanalDistribuicao> = yield call(self.getCanalDistByFuncionario, funcionario);
                console.log("resp getCanalDistByFuncionarioEffect", resp);
                switch (resp.status) {
                    case "ok":
                        yield put(self.reducer.resultAfterEffects(
                            { ...self.state, loading: false, canalAberto: resp.row, msg: "Canal de distribuição encontrado", status: "ok", error: false },
                            self.actionsType.getCanalDistByFuncionario
                        ))
                        break;
                    case "not_found":
                        //adicionar um novo canal de distribuição
                        yield put(self.reducer.actions.addCanalDist(funcionario));
                        break;
                    case "error":
                        yield put(self.reducer.resultAfterEffects(
                            { ...self.state, loading: false, msg: resp.msg as string, status: "error", error: true, showAlert: true },
                            self.actionsType.getCanalDistByFuncionario
                        ))
                        break;
                }

            } else {
                console.log("getCanalDistByFuncionarioEffect: funcionario não informado");
            }
        }
        catch (error: any) {
            console.log("error getCanalDistByFuncionario", error);
            let msg = "Ops, ocorreu uma falha em getCanalDistByFuncionario, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(self.reducer.resultAfterEffects(
                { ...self.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                self.actionsType.getCanalDistByFuncionario
            ))
        }
    }

    addCanalDist = async (funcionario: Funcionario): Promise<ResultDb<CanalDistribuicao>> => {
        try {
            if (!isEmpty(funcionario._id)) {
                //adicionar um novo canal de distribuição
                let canalDist: CanalDistribuicao = { ...initialValueState.row, funcionario };
                canalDist.data = new Date().toISOString();
                canalDist.situacao = "ABERTO";
                canalDist.fechamento = {
                    resumo_mp: [],
                    total: 0
                };
                canalDist.estoque_dist = [];
                canalDist.despesas = [];
                const resp: ResultDb<CanalDistribuicao> = await this.db.salvar(canalDist);
                return resp;
            } else {
                return { status: "error", msg: "Funcionário não informado." };
            }
        }
        catch (error: any) {
            console.log("error addCanalDist", error);
            let msg = "Ops, ocorreu uma falha em addCanalDist, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            return { status: "error", msg: err };
        }
    }

    private * addCanalDistEffects(actions: Payload) {
        const self = actions.payload.this as CanalDistribuicaoController;
        const { funcionario } = actions.payload;
        try {
            if (!isEmpty(funcionario._id)) {
                yield put(self.reducer.resultAfterEffects(
                    { ...self.state, loading: true, msg: "Adicionando canal de distribuição...", status: "loading", error: false, showAlert: false },
                    self.actionsType.addCanalDist
                ));
                const resp: ResultDb<CanalDistribuicao> = yield call(self.addCanalDist, funcionario);
                console.log("resp addCanalDist canalDistri", resp);
                if (resp.status === "ok") {
                    yield put(self.reducer.resultAfterEffects(
                        { ...self.state, loading: false, canalAberto: resp.row, msg: "Canal de distribuição adicionado com sucesso", status: "ok", error: false },
                        self.actionsType.addCanalDist
                    ))
                } else {
                    yield put(self.reducer.resultAfterEffects(
                        { ...self.state, loading: false, msg: "Ops, ocorreu uma falha ao adicionar o canal de distribuição", status: "error", error: true, showAlert: true },
                        self.actionsType.addCanalDist
                    ))
                }
            }
        }
        catch (error: any) {
            console.log("error addCanalDistEffect", error);
            let msg = "Ops, ocorreu uma falha em addCanalDistEffect, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(self.reducer.resultAfterEffects(
                { ...self.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                self.actionsType.addCanalDist
            ))
        }
    }

}

export const canalDistController = new CanalDistribuicaoController()

export const mapStateToCanalDistribuicaoProps = (state: ApplicationState) => ({
    canalDistribuicaoState: state.canalDistribuicaoState,
    funcionarioState: state.funcionarioState,
    contasState: state.contasState,
})

export const mapDispatchToCanalDistribuicaoProps = (dispatch: Dispatch) => ({
    canalDistribuicaoActions: bindActionCreators({ ...canalDistController.reducer.actions }, dispatch),
    funcionarioActions: bindActionCreators({ ...funcionarioController.reducer.actions }, dispatch),
    contasActions: bindActionCreators({ ...contasController.reducer.actions }, dispatch),
})
